import styled from "styled-components";

export const PageContainer = styled.main`
  display: flex;
  min-height: 100vh;
  background: #fdfdfd;
`;

export const BrandPanel = styled.aside`
  width: 40%;
  min-height: 100vh;
  background-color: #fdfdfd;
  background-image: url("/frame.svg");
  background-position: right;
  background-size: cover;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const Content = styled.section`
  display: flex;
  flex: 1;
  justify-content: center;
  overflow-y: auto;
  padding: 2rem 1rem 3rem;
`;

export const FormArea = styled.div`
  width: 100%;
  max-width: 32rem;
`;

export const Logo = styled.img`
  display: block;
  width: 220px;
  height: auto;
  margin: 0 auto;
`;
